<template>
  <BaseCard
    :heading="$t(`${resourceType}.services_availability_title`)"
    :info="$t(`${resourceType}.services_availability_info`)"
  >
    <BaseGroupedCheckboxList
      v-if="listData.length"
      v-model="listValue"
      :data="listData"
      :label="$t('resource.all_treatments')"
      :fixedValue="fixedValue"
      expandedHeader
      gray
    />
  </BaseCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useServicesStore } from '@/stores/services';

export default defineComponent({
  name: 'ResourceServices',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    disableDeselect: {
      type: Boolean,
      default: false,
    },
    resourceType: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props) {
    return {
      fixedValue: props.disableDeselect ? props.modelValue : null,
    };
  },
  computed: {
    listValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    listData() {
      const { categoriesWithServices } = useServicesStore();
      const _categoriesWithServices = categoriesWithServices.filter(
        (category) => category.services.length,
      );
      return _categoriesWithServices.length
        ? _categoriesWithServices.map((category) => ({
            label: category.name,
            color: category.color,
            items: category.services.map((service) => ({
              label: service.name,
              id: service.id,
            })),
          }))
        : [];
    },
  },
});
</script>
